function sendCityForm(form) {
    const URL = form.getAttribute('action')
    const nodes = form.querySelectorAll('input')
    nodes[nodes.length - 1].value = location.href

    try {
        fetch(URL, {
            method: 'POST',
            body: formDataBuilder(nodes, form)
        }).then(res => res.json()).then(data => {
            const wrap = form.closest('div')
            wrap.innerHTML = `
            <div class="popup-contacts-city__heading">
                <h2 class="popup-contacts-city__title">${data.title}</h2>
            </div>
            <p>${data.text}</p>
            `
        })
    } catch (error) {
        console.log(error)
    }

    return false
}

document.addEventListener('DOMContentLoaded', () => {
    const popup_city = document.querySelector('#popup-city')
    const popup_contacts = document.querySelector('#popup-contacts-city')

    if (popup_city) {
        $.fancybox.open({
            src: `#${popup_city.id}`,
            type: 'inline',
        });
    }

    if (popup_contacts) {
        setTimeout(() => {
            const interval = setInterval(() => {
                if (document.querySelector('.popup-city._bs.fancybox-content')) return
                $.fancybox.open({
                    src: `#${popup_contacts.id}`,
                    type: 'inline'
                });
                clearInterval(interval)
            }, 1000)
        }, 5000)
    }
})